import { IExtsvcServerSettings } from '../../../../types/IEditableServerSettings';
import { ITagResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { TagRequest } from '../../../TagRequest';

export interface IUpdateExtsvcServerSettingsParams {
  settings: IExtsvcServerSettings;
}

export type IUpdateExtsvcServerSettingsResult = ITagResult & IExtsvcServerSettings;

export class UpdateExtsvcServerSettingsRequest extends TagRequest<IExtsvcServerSettings, IUpdateExtsvcServerSettingsResult> {
  constructor(params: IExtsvcServerSettings) {
    super('analyticsextensions', 'updateAnalyticsExtensionsServerSettings', params);
  }
}
